import { createReducer, on } from '@ngrx/store';

import { goToProjects, setProject } from '../../core/store';
import {
	bulkDeleteDashboards,
	deleteDashboard,
	deleteDashboardFail,
	deleteDashboardSuccess,
	fetchDashboardListFail,
	fetchDashboardListSuccess,
	initDashboardList,
	refreshDashboardList,
} from './dashboard.actions';
import { DashboardMainSliceState } from './dashboard.state';

export const dashboardOriginalReducer = createReducer<DashboardMainSliceState>(
	new DashboardMainSliceState(),
	on(goToProjects, setProject, (state) => state.clear()),
	on(initDashboardList, refreshDashboardList, (state) =>
		state.setLoading(true)
	),
	on(fetchDashboardListFail, (state) => state.setLoading(false)),
	on(fetchDashboardListSuccess, (state, action) =>
		state.setLoading(false).setDashboardList(action.dashboardList)
	),
	on(deleteDashboard, bulkDeleteDashboards, (state) => state.setLoading(true)),
	on(deleteDashboardSuccess, (state) => state.setDeleteSuccess(true)),
	on(deleteDashboardFail, (state) =>
		state.setDeleteSuccess(false).setLoading(false)
	)
);
